export enum FarmPageProps {
  PAGE_TITLE = 'Farm',
}

export enum commodityDropdown {
  AGRICULTURE = 'Agriculture Commodity',
  LIVE_STOCK = 'Live Stock Commodity',
  VALUE = 'New Commodity',
}

export enum tabsActiveScope {
  SCOPE_1 = 'scope1',
  SCOPE_2 = 'scope2',
  SCOPE_3 = 'scope3',
  SCOPE_3_DOWNSTREAM = 'scope3Downstream',
  SCOPE_3_UPSTREAM = 'scope3Upstream',
  COMMODITY = 'commodity',
}

export enum CommodityTabsKeys {
  ALL_COMMODITIES = 'all-commodities',
  IN_REVIEW = 'in-review',
  APPROVED = 'approved',
  DRAFT = 'draft',
  DECLINED = 'declined',
  FARM = 'farm',
}

export enum LiveStockTypes {
  BEEF = 'beef'
}

export enum LiveStockStagesTYPES {
  GROWTH_STAGE = 'growth_stages',
  MANURE_MANAGEMENT = "manure_management_types"
}

export enum CommodityTabsLabels {
  ALL_COMMODITIES = 'All Commodities',
  IN_REVIEW = 'In review',
  APPROVED = 'Approved',
  DRAFT = 'Draft',
  DECLINED = 'Declined',
}

export enum FormCommodityTypes {
  AGRICULTURE = 'Agriculture',
  LIVE_STOCK = 'Livestock',
}
